import { render, staticRenderFns } from "./RedactorTabs.vue?vue&type=template&id=91b61084&scoped=true&"
import script from "./RedactorTabs.vue?vue&type=script&lang=js&"
export * from "./RedactorTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b61084",
  null
  
)

export default component.exports